import type { ThinkingLevel } from "@rakazo/contracts";

/** Calls favor conversational pacing; ordinary reading and background work keep their defaults. */
export const CALL_SPEECH_RATE = 1.15;

export function callThinkingLevel(configured: ThinkingLevel | null | undefined): ThinkingLevel {
  return configured === "off" || configured === "minimal" ? configured : "low";
}
